'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _stringUtil = require('../../../common/utils/stringUtil');

var _recompose = require('recompose');

require('./ContainerElementChildCount.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var getChildTypeCount = function getChildTypeCount(childrenTypes, type) {
    return childrenTypes[type] || 0;
};

// Styles


var showBoardCount = function showBoardCount(childrenTypes) {
    return !!childrenTypes.board;
};
var showCardCount = function showCardCount(childrenTypes) {
    return !!childrenTypes.card || !showBoardCount(childrenTypes);
};

var showTypeCount = function showTypeCount(childrenTypes, type) {
    return type === 'board' ? showBoardCount(childrenTypes) : showCardCount(childrenTypes);
};

var getChildTypeCountDescription = function getChildTypeCountDescription(childrenTypes, type) {
    var count = getChildTypeCount(childrenTypes, type);
    return showTypeCount(childrenTypes, type) ? count + ' ' + (0, _stringUtil.pluralise)(type, count) : '';
};

var getSeparator = function getSeparator(childrenTypes) {
    return showCardCount(childrenTypes) && showBoardCount(childrenTypes) ? ', ' : '';
};

var ContainerElementChildCount = function ContainerElementChildCount(_ref) {
    var childrenTypes = _ref.childrenTypes,
        show = _ref.show;

    var boardText = getChildTypeCountDescription(childrenTypes, 'board');
    var cardText = getChildTypeCountDescription(childrenTypes, 'card');
    var separator = getSeparator(childrenTypes);

    return _react2.default.createElement(
        'div',
        { className: 'ContainerElementChildCount' },
        _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)('text', { show: show }) },
            boardText + separator + cardText
        )
    );
};

ContainerElementChildCount.propTypes = {
    childrenTypes: _propTypes2.default.object,
    show: _propTypes2.default.bool
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(ContainerElementChildCount);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/containerElement/ContainerElementChildCount.js
// module id = 724
// module chunks = 0